import { create } from "zustand";
import type { NoteDuration, TechniqueId, NoteEvent } from "../types/domain";

export type GraceMode = "" | "h" | "sl";   // pen grace transition: off / hammer / slide

interface EditorState {
  editMode: boolean;
  activeMeasure: number;     // measure being edited, or -1
  selectedNoteIdx: number;   // raw note index within the active measure, or -1
  insertArmed: boolean;      // true = 추가(insert) mode, false = 선택(select) mode
  curDur: NoteDuration;      // note-pen length
  curDotted: boolean;        // note-pen dotted (점음표) flag
  curTriplet: boolean;       // note-pen triplet (3연음) flag
  // pen technique state — in 추가(insert) mode these arm the NEXT note instead of editing the current one
  curFx: TechniqueId[];
  curTie: boolean;
  curGrace: GraceMode;
  restDur: NoteDuration;     // rest-pen length
  curRestDotted: boolean;    // rest-pen dotted (점쉼표) flag
  pendingBeat: { m: number; b: number } | null;   // last beat clicked while NOT editing → edit entry point
  // 범위(range) selection for copy/cut/paste — global {measure, beat} endpoints, can span measures
  rangeMode: boolean;
  rangeAnchor: { m: number; b: number } | null;
  rangeEnd: { m: number; b: number } | null;
  clipboard: NoteEvent[] | null;   // copied raw notes (deep-cloned, flattened across measures)

  set: (patch: Partial<EditorState>) => void;
  reset: () => void;
}

const initial = { editMode: false, activeMeasure: -1, selectedNoteIdx: -1, insertArmed: false, curDur: 8 as NoteDuration, curDotted: false, curTriplet: false, curFx: [] as TechniqueId[], curTie: false, curGrace: "" as GraceMode, restDur: 8 as NoteDuration, curRestDotted: false, pendingBeat: null,
  rangeMode: false, rangeAnchor: null as { m: number; b: number } | null, rangeEnd: null as { m: number; b: number } | null, clipboard: null as NoteEvent[] | null };

export const useEditorStore = create<EditorState>((set) => ({
  ...initial,
  set: (patch) => set(patch),
  reset: () => set(initial),
}));
